var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { faFileDownload } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQueryClient } from "@tanstack/react-query";
import { Inline, Inset } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import getPrivacyPolicyPdfName from "./helpers";
import { PolicyLink, StatementsTableFooter } from "./subcomponents";
import endPoints from "../../../const/endpoints";
import queryKeys from "../../../const/queryKeys";
import { useAccountSummary } from "../../../const/syfApiQueries";
import { useConfig } from "../../../hooks/useConfig";
var PrivacyPolicyLink = function (_a) {
    var accountId = _a.accountId;
    var assets = useConfig().hosts.assets;
    var t = useTranslation().t;
    var queryClient = useQueryClient();
    var accountSummary = useAccountSummary(accountId).data;
    var privacyPolicies = queryClient.getQueryData([
        queryKeys.privacyPolicy,
    ]);
    var pdfFileName = getPrivacyPolicyPdfName({
        accountSummary: accountSummary,
        privacyPolicies: privacyPolicies,
    });
    if (!privacyPolicies || !pdfFileName) {
        return _jsx("div", { "data-testid": "policy-error" });
    }
    return (_jsxs(Inset, __assign({ left: "large" }, { children: [_jsx(StatementsTableFooter, { children: _jsx(PolicyLink, __assign({ href: "".concat(assets.origin).concat(endPoints.digitalAssets, "/privacy-policies/").concat(pdfFileName), target: "_blank", "data-type": "statements", "data-analytics": "clicktrackingevent", "data-reason": "privacy policy", "data-object": "link" }, { children: _jsxs(Body, __assign({ weight: "bold" }, { children: [_jsx(FontAwesomeIcon, { icon: faFileDownload }), _jsx(Inline, { size: "small" }), t("modal.table.privacy")] })) })) }), _jsx(Inline, { size: "xlarge" })] })));
};
export default PrivacyPolicyLink;
